export type PatientAccessScope =
  | {
      scope: 'organization'
    }
  | {
      scope: 'prescriber'
      prescriberId: string
    }

type PatientAccessScopeOptions = {
  isSharedPatientsEnabled: boolean
  prescriberId?: string
}

export const getPrescriberIdForScope = (scopeData: PatientAccessScope): string | undefined => {
  if (scopeData.scope === 'organization') {
    return undefined
  }
  return scopeData.prescriberId
}

export const getPatientAccessScope = ({
  isSharedPatientsEnabled,
  prescriberId,
}: PatientAccessScopeOptions): PatientAccessScope | null => {
  if (isSharedPatientsEnabled) {
    return { scope: 'organization' }
  }

  if (!prescriberId) {
    return null
  }

  return {
    scope: 'prescriber',
    prescriberId,
  }
}

export const getMissingPrescriberMessage = (action: string) =>
  `A prescriber must be selected before ${action}.`
